export default __webpack_public_path__ + "static/California-807c4c0e87ba0fd5d0426090502a0bfb.webp";